module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['chat-input-bar', {
      'chat-input-bar--locked': _vm.locked
    }]
  }, [(_vm.locked) ? _c('div', {
    staticClass: "chat-input-row"
  }, [_c('svg', {
    staticClass: "chat-locked-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "11",
      "width": "18",
      "height": "11",
      "rx": "2",
      "ry": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7 11V7a5 5 0 0 1 10 0v4"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "chat-locked-text"
  }, [_vm._v(_vm._s(_vm.lockedText))])]) : [_c('div', {
    staticClass: "chat-input-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputText),
      expression: "inputText"
    }],
    staticClass: "chat-input",
    attrs: {
      "placeholder": "Reply to continue...",
      "disabled": _vm.loading
    },
    domProps: {
      "value": (_vm.inputText)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSend.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "chat-input-send",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.handleSend
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"
    }
  })])])]), _vm._v(" "), (_vm.cardMismatchHint) ? _c('span', {
    staticClass: "chat-input-hint"
  }, [_vm._v(_vm._s(_vm.cardMismatchHint))]) : _vm._e()]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-717f98d6","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/chat-panel/ChatInputBar.vue
// module id = htw4
// module chunks = 1